<div
    class="search"
    [ngClass]="{
        'search-selected': searchSelected && !searchSubmitAttempt,
        'search-submit': searchSubmitAttempt && searchControl.valid,
        'search-invalid': searchControl.invalid && (searchControl.dirty || searchControl.touched),
    }">
    <input
        class="search-input"
        type="text"
        [formControl]="searchControl"
        (focus)="searchFocus()"
        (blur)="searchBlur()"
        [placeholder]="placeholder"
        (keyup.enter)="activateSearch()"
        (input)="onChange()" />
    <div class="static-images">
        <img
            *ngIf="searchSubmitAttempt && searchControl.valid"
            class="cancel"
            (click)="deactivateSearch()"
            src="assets/images/common/cancel-figma.svg"
            alt="cancel" />
        <div *ngIf="searchSubmitAttempt && searchControl.valid" class="separator"></div>
        <img
            class="icon"
            (click)="activateSearch()"
            [ngClass]="{
                'icon-selected': searchControl.value,
                'icon-invalid': !searchControl.valid,
            }"
            src="assets/images/common/search.svg"
            alt="search" />
    </div>
</div>
